import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem } from 'reactstrap';
import { NavLink } from "react-router-dom"
import { IconButton } from '@fluentui/react';
import { initializeIcons } from '@fluentui/font-icons-mdl2';
import Image from 'react-bootstrap/Image'
import { Link } from 'react-router-dom';
import { UserLogin } from './UserLogin';
import './NavMenu.css';
import logo from '../Images/logo.png'
import { msalAuth, prepareHeader , Roles } from "./AuthProvider";
import { APIAuth } from '../msal/MsalConfig';
import banner from '../Images/banner.png';


export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true,
            RoleID: props.RoleID,
            SeasonName: new Date().getFullYear() + "-" + (new Date().getFullYear() + 1).toString().substring(2),
            UserID : props.UserID
        };
        initializeIcons();
        console.log(process.env.REACT_APP_ENVIRONMENT);
    }

    toggleNavbar() {  
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    componentDidMount() {
        let userAccount = this.props.msalContext.instance.getAllAccounts()[0];
        console.log(userAccount);
        msalAuth.acquireTokenSilent({
            ...APIAuth,
            account: msalAuth.getAllAccounts()[0]
        }).then((response) => {
        const headers = new Headers();
        const bearer = `Bearer ${response.accessToken}`;

        headers.append("Authorization", bearer);

        const options = {
            method: "GET",
            headers: headers
        };
        fetch('Account/CheckAuth?email=' + userAccount.username , options)
            .then((response) => response.json())
            .then((data) => {
                console.log(data);
                /* if (data.id ) {*/
                var result = JSON.parse(data);
                console.log(result);
                this.setState({
                    RoleID: result.RoleId,
                    UserID: result.ID
                })


                /* }*/
            })
        });


        msalAuth.acquireTokenSilent({
            ...APIAuth,
            account: msalAuth.getAllAccounts()[0]
        }).then((response) => {
            fetch('Season/FetchSeason', prepareHeader(response, "GET"))
                .then((response) => response.json())
                .then(data => {
                    console.log(JSON.parse(data));
                    var result = JSON.parse(data);
                    var seasons = result.map(value => ({
                        id: value.Id,
                        name: value.SeasonName,
                        isActive: value.IsActive
                    }))
                    var seasons = seasons.filter(f => f.isActive == 1)
                    console.log(seasons);
                    this.setState({
                        SeasonName: seasons[0].name,
                    })
                });
        })
    }

    hideNavigationMenu(event) {
        this.state.collapsed = false;
            this.setState({
                collapsed: !this.state.collapsed
            });
    }

    render() {
        const defaultPic = "data:image/svg+xml;base64,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";
        return (
            
            <header>
               
                <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3 wld-navbar" light>
                    <Container>
                        {process.env.REACT_APP_ENVIRONMENT != 'PROD' ? 
                            <NavbarBrand className="box">
                                <img className="triangle" src={banner} />
                                <p className="text">{process.env.REACT_APP_ENVIRONMENT}</p>
                            </NavbarBrand> : ""
                        }
                        <h1>  {process.env.CLIENT_ID}</h1>
                        <NavbarBrand tag={Link} to="/"><img className="logo" src={logo} /></NavbarBrand>
                        <NavbarToggler  onClick={this.toggleNavbar} className="mr-2" />
                        <Collapse className="d-sm-inline-flex navigation-menu" id="navigationmenu" isOpen={!this.state.collapsed} navbar>
                            <ul id="navigationlist" class="navbar-nav">
                                <NavItem className="ms-auto Customlogo" style={{display:"none"} }>
                                    <UserLogin {...this.props} />
                                    </NavItem>                                   
                                <NavItem>
                                    <NavLink tag={Link} exact activeClassName="active" onClick={() => this.hideNavigationMenu()} className="text-white" to="/">Home</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} exact activeClassName="active" className="text-white" onClick={() => this.hideNavigationMenu()} to="/games">Games</NavLink>
                                </NavItem>
                                {this.state.RoleID?.some(s=> Roles.generalAdmins.includes(s)) ?
                                    <React.Fragment>
                                <NavItem>
                                    <NavLink tag={Link} exact activeClassName="active" className="text-white" onClick={() => this.hideNavigationMenu()} to="/seasons">Season</NavLink>
                                </NavItem>
                                <NavItem>
                                            <NavLink tag={Link} exact activeClassName="active" className="text-white" onClick={() => this.hideNavigationMenu()} to="/employees">Employees</NavLink>
                                </NavItem>

                                {/*<NavItem>*/}
                                {/*    <NavLink tag={Link} exact activeClassName="active" className="text-white" to="/schedule">Schedules</NavLink>*/}
                                {/*</NavItem>*/}
                                <NavItem>
                                            <NavLink tag={Link} exact activeClassName="active" className="text-white" onClick={() => this.hideNavigationMenu()} to="/maintenance-schedule">Maintenance</NavLink>
                                </NavItem>
                                    </React.Fragment>
                                    : ""
                                }

                            </ul>
                           
                            {/*<div className="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">*/}
                            {/*    <ul>*/}
                            {/*        <NavItem className="activeSeason">*/}
                            {/*            {this.state.SeasonName}*/}
                            {/*        </NavItem>*/}
                            {/*    </ul>*/}
                            {/*</div>*/}
                            <div className="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
                                <ul>
                                    {/*<NavItem className="me-2">*/}
                                    {/*    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" fill="#DFC9A2" className="bi bi-bell" viewBox="0 0 16 16">*/}
                                    {/*        <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z" />*/}
                                    {/*    </svg>*/}
                                    {/*</NavItem>*/}

                                    {/*<NavItem className="ms-auto">*/}
                                    {/*    <IconButton*/}
                                    {/*        iconProps={{ iconName: 'Settings' }}*/}
                                    {/*        styles={{*/}
                                    {/*            icon: { color: '#DFC9A2', fontSize: 24 },*/}
                                    {/*            root: {*/}
                                    {/*                height: 0,*/}
                                    {/*                top: 10,*/}
                                    {/*                selectors: {*/}
                                    {/*                    ':hover .ms-Button-icon': {*/}
                                    {/*                        color: '#DFC9A2'*/}
                                    {/*                    },*/}
                                    {/*                    ':active .ms-Button-icon': {*/}
                                    {/*                        color: '#DFC9A2'*/}
                                    {/*                    }*/}
                                    {/*                }*/}
                                    {/*            }*/}
                                    {/*        }} />*/}
                                    {/*</NavItem>*/}
                                    {/*<NavItem className="ms-auto">*/}
                                    {/*    <IconButton*/}
                                    {/*        iconProps={{ iconName: 'StatusCircleQuestionMark' }}*/}
                                    {/*        styles={{*/}
                                    {/*            icon: { color: '#DFC9A2', fontSize: 40 },*/}
                                    {/*            root: {*/}
                                    {/*                height: 0,*/}
                                    {/*                top: 15,*/}
                                    {/*                selectors: {*/}
                                    {/*                    ':hover .ms-Button-icon': {*/}
                                    {/*                        color: '#DFC9A2'*/}
                                    {/*                    },*/}
                                    {/*                    ':active .ms-Button-icon': {*/}
                                    {/*                        color: '#DFC9A2'*/}
                                    {/*                    }*/}
                                    {/*                }*/}
                                    {/*            }*/}
                                    {/*        }} />*/}
                                    {/*</NavItem>*/}
                                    <NavItem className="ms-auto">
                                        <UserLogin UserID={this.state.UserID} {...this.props} />
                                    </NavItem>
                                </ul>
                            </div>

                        </Collapse>

                    </Container>
                </Navbar>
            </header>
        );
    }
}
